import { cn } from '~/lib'
import type { ClientIncentive } from '~/models'

type ListingIncentivesProps = {
  incentives: ClientIncentive[]
  className?: string
}

export default function ListingIncentives({
  incentives,
  className,
}: ListingIncentivesProps) {
  if (incentives.length === 0) {
    return null
  }

  return (
    <>
      <ul className={cn('incentives space-y-4', className)}>
        {incentives.map((incentive) => (
          <li key={incentive.id}>
            <p className="font-medium">{incentive.name}</p>
            {incentive.description && (
              <div
                className="mt-1 whitespace-pre-line text-sm"
                dangerouslySetInnerHTML={{ __html: incentive.description }}
              />
            )}
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs italic text-muted-foreground">
        Incentives are for informational purposes only and are not guaranteed.
        Availability, eligibility, and terms may vary. Contact the relevant
        municipality to confirm eligibility for this property.
      </p>
    </>
  )
}
